module.exports = __webpack_public_path__ + "img/quality-assurance-analyst.89ed202a.jpg";